module.exports = __webpack_public_path__ + "img/inmanage.e95ff62e.svg";